var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog center-dialog",
      attrs: {
        title: `设备号关联详情 - ${_vm.deviceNo}`,
        visible: _vm.visible,
        "append-to-body": "",
        width: "80%",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": (val) => _vm.$emit("update:visible", val),
        closed: _vm.handleClosed,
      },
    },
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        staticStyle: { height: "600px" },
        attrs: {
          "layout-mode": "dialog",
          immediate: false,
          "search-schema": [],
          columns: _vm.tableColumns,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
          "table-attrs": _vm.tableAttrs,
        },
        scopedSlots: _vm._u([
          {
            key: "colAccount",
            fn: function ({ row }) {
              return [
                _c("MemberAccountCell", {
                  attrs: {
                    row: row,
                    username: row.username,
                    uid: row.uid,
                    "vip-level": row.vip_level,
                    clickable: false,
                    "enable-detail-dialog": false,
                  },
                }),
              ]
            },
          },
          {
            key: "colStatus",
            fn: function ({ row }) {
              return [
                _c(
                  "el-tag",
                  {
                    attrs: {
                      size: "small",
                      type: row.inviter_status === 1 ? "success" : "danger",
                    },
                  },
                  [_vm._v(_vm._s(row.inviter_status === 1 ? "启用" : "禁用"))]
                ),
              ]
            },
          },
          {
            key: "colAgentBackGold",
            fn: function ({ row }) {
              return [
                _vm._v(
                  " " + _vm._s(_vm.formatAmount(row.agent_back_gold)) + " "
                ),
              ]
            },
          },
          {
            key: "colShareGoldToInviter",
            fn: function ({ row }) {
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.formatAmount(
                        row.share_two_gold_to_inviter +
                          row.share_one_gold_to_inviter
                      )
                    ) +
                    " "
                ),
              ]
            },
          },
          {
            key: "colTotalPayinAmount",
            fn: function ({ row }) {
              return [
                _vm._v(
                  " " + _vm._s(_vm.formatAmount(row.total_payin_amount)) + " "
                ),
              ]
            },
          },
          {
            key: "colTotalBetAmount",
            fn: function ({ row }) {
              return [
                _vm._v(
                  " " + _vm._s(_vm.formatAmount(row.total_bet_amount)) + " "
                ),
              ]
            },
          },
          {
            key: "colIp",
            fn: function ({ row }) {
              return [_vm._v(" " + _vm._s(_vm.ip) + " ")]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }